import React from "react"
import Modal from "aldoo-ra/Modal"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import Spinner from "aldoo-ra/Spinner"
import TextBundle from "aldoo-ra/CMS/text-bundle"

export default function DownloadLimitModal({
  isOpen,
  onClose,
  currentLimit,
  limitValue,
  setLimitValue,
  limitSaving,
  onSave,
  onRemove,
}) {
  const texts = TextBundle({ id: "transfer_share_dashboard" })
  return (
    <Modal variant="meet_compact" isOpen={isOpen} onClose={onClose}>
      <div className="p-6 w-full">
        <Typography variant="h4" className="mb-2">
          {texts?.downloadLimit}
        </Typography>
        <Typography variant="body2" className="text-text_secondary mb-4">
          {texts?.downloadLimitDesc}
        </Typography>
        <input
          type="number"
          min="1"
          value={limitValue}
          onChange={(e) => setLimitValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              const n = parseInt(limitValue, 10)
              if (n > 0) onSave(n)
            }
          }}
          placeholder={texts?.eg10}
          className="w-full text-sm bg-neutral_1 border border-bordered rounded-lg px-3 py-2.5 text-text placeholder:text-text_secondary outline-none focus:border-primary transition-colors mb-4"
          autoFocus
        />
        <div className="flex gap-2">
          {currentLimit != null && (
            <Button variant="secondary" className="flex-1" disabled={limitSaving} onClick={onRemove}>
              {texts?.removeLimit}
            </Button>
          )}
          <Button
            variant="primary"
            className="flex-1"
            disabled={limitSaving || !limitValue || parseInt(limitValue, 10) < 1}
            onClick={() => onSave(parseInt(limitValue, 10))}
          >
            {limitSaving ? <Spinner className="w-[16px] h-[16px]" /> : texts?.save}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
